export function isPngImage(src?: string | null) {
  if (!src) {
    return false;
  }

  const normalized = src.split("?")[0]?.split("#")[0] ?? "";
  return normalized.toLowerCase().endsWith(".png");
}
